import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLSubscribe } from '../utils/methods/graphql.subscribe';

@Injectable()
export class ReorderItemOperationSubscription extends GraphQLSubscribe {
	override command: DocumentNode = gql`
		subscription OnReorderItemOperation {
			onReorderItemOperation {
				id
				sourceId
				nextId
				alias
				terminalId
				batchId
				calculatedMillisecondsPerItem
				detailAlias
				group
				itemData
				stockItems {
					stockItemKey
					description
					amount
					unit
				}
				items {
					sequenceNumber
					reordered
					completed
					ready
					location {
						name
						placement
					}
				}
			}
		}
	`;
}
